import { createSkeletonElement } from '@trainline/react-skeletor'
import styled from 'styled-components'
import { Icon } from 'antd'
import Button from 'web-makeup/dist/Button'

export const MainContainer = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  overflow-y: auto;
`

export const StyledH3 = styled(createSkeletonElement('h3'))`
  font-size: 1.125rem;
  line-height: 1.33;
`

export const RequestDetailsContainer = styled.div`
  background-color: white;
  border-right: solid 1px #d1d1d1;
  max-width: 30.5rem;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const DetailsHeader = styled.div`
  border-bottom: solid 1px #d1d1d1;
`

export const BrandMessageContainer = styled.div`
  margin: 2rem 1.5rem;
  grid-gap: 2rem;
  display: grid;
  grid-template-rows: 4rem 1fr;
`

export const Entity = styled.div`
  display: grid;
  grid-template-columns: 4rem 1fr;
  grid-gap: 1rem;
`

export const MainDescription = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  align-items: center;
`

export const RequestType = styled(createSkeletonElement('span'))`
  color: #4a4a4a;
  font-size: 0.875rem;
`

export const RequestMessage = styled(createSkeletonElement('div'))`
  display: grid;
  grid-gap: 0.5rem;
  overflow-y: auto;
  font-size: 1rem;

  ul,
  ol {
    padding-inline-start: 2rem;
    margin-block-start: 0.5rem;
    margin-block-end: 0.5rem;
  }

  li {
    display: list-item;
  }

  a {
    color: #06c;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const ProducerDetails = styled.div`
  border-top: solid 1px #d9d9d9;
  display: grid;
  padding: 2rem 0;
  grid-gap: 1rem;

  border-bottom: solid 1px #d9d9d9;
`

export const SectionTitle = styled.div`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  color: #484848;
`

export const Producer = styled.div`
  display: grid;
  grid-template-columns: 4rem auto;
  grid-column-gap: 0.5rem;
  align-items: start;
`

export const AssigneeInfo = styled.div`
  display: grid;
  grid-gap: 0.5rem;
`

interface IconProps {
  color: string
}

export const StyledIcon = styled(Icon)`
  color: ${(props: IconProps) => props.color};
  font-size: 1.25rem;
`

export const AssigneeProp = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: start;
  align-items: center;
  grid-column-gap: 0.25rem;
`

export const FullWidthButtonGroup = styled(Button.Group)`
  && {
    width: 100%;
    display: flex;
    .ant-btn {
      flex: 1;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/RequestDetailsPage/RequestDetailsPage.style.tsx